import React, { useEffect, useState } from "react";
import { TemplatesFilters } from "@/components/View/TemplatesView";
import TemplateHero from "@/components/View/TemplateView/TemplateHero";
import WhatsChangedDeepDive from "images/templates/whats_changed_deep_dive.png";
import WhatsChangedOverview from "images/templates/whats_changed_overview.png";
import DocumentQuestion from "images/templates/document_question.png";
import WhatsChangedRetail from "images/templates/whats_changed_retail.png";
import WhatsChangedFinancial from "images/templates/whats_changed_financial.png";
import WhatsChangedOverviewRetail from "images/templates/whats_changed_overview_retail.png";
import DocumentCustomerService from "images/templates/document_customer_service.png";
import DocumentContextAwareChat from "images/templates/document_context_aware_chat.png";
import SparkRightPanel from "@/components/View/Spark/SparkRightPanel";
import WhatsChangedIcon from "images/Agent Icons/WhatsChanged/Whats-Changed.svg";
import KpiDriversIcon from "images/Agent Icons/WhatsChanged/Base KPI Driver Dashboard.svg";
import SparkTemplatesList from "@/components/View/Spark/SparkTemplatesList";
import HealthcareOverviewIcon from "images/Agent Icons/WhatsChanged/Healthcare Overview.png";
import BackToChat from "images/back-to-chat.svg";
import WhatsChangedBaseIcon from "images/Agent Icons/WhatsChanged/whats changed base.svg";
import KpiOverviewBaseIcon from "images/Agent Icons/WhatsChanged/KPI Overview Base.svg";
import DocSumBaseIcon from "images/Agent Icons/DocSum/doc sum base.svg";
import { DEFAULT_BLUEPRINT_DETAILS, SAMPLE_DOCSUM_WIZARD, SAMPLE_WHATS_CHANGED_WIZARD } from "@/containers/ChatGPT/reducer";
import JustChatUsecaseIcon from "images/Agent Icons/just-chat.svg";
import DocSumHrIcon from "images/Agent Icons/DocSum/HR.svg";
import { useDispatch, useSelector } from "@/types/store";
import * as viewReducer from "@/containers/View/reducer";
import * as tagsReducer from "@/containers/Tags/reducer";
import * as foldersReducer from "@/containers/Folders/reducer";
import * as globalReducer from "@/containers/App/reducer";
import SparkDocsRightPanel from "@/components/View/Spark/SparkDocsRightPanel";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";
import VideoOverview from "images/docs/whats-changed-overview.mp4";
import VideoDeepDive from "images/docs/whats-changed-deep-dive.mp4";
import VideoDocSum from "images/docs/document-summarization.mp4";
import { Button } from "@/aible";
import { updateType, VIEW_TYPE } from "@/containers/View/reducer";
import { cn } from "@/utils/cn";
import { isEnabled } from "@/utils/featureFlags";
export const SPARK_TEMPLATES = [
    {
        ...DEFAULT_BLUEPRINT_DETAILS,
        id: "FINANCIAL_CONSUMER_COMPLAINTS_WHATS_CHANGED",
        name: "Financial Consumer Complaints: What's Changed Deep Dive",
        wizard: {
            ...SAMPLE_WHATS_CHANGED_WIZARD,
            base64StringLogo: WhatsChangedIcon,
            base64StringBot: WhatsChangedIcon,
            description: "Easily explore insights about Financial Consumer Complaints to analyze what's changed from your date range",
            steps: {
                0: {
                    chatBlueprintId: "CHATAIBLE_WHATS_CHANGED"
                }
            },
            tags: ["BANKING", 10, "WHATS_CHANGED"],
            templateSample: "FINANCIAL_CONSUMER_COMPLAINTS_WHATS_CHANGED",
            templateSampleType: "DATASET",
            templateType: "WHATS_CHANGED_KPI",
            startInDashboard: false,
            chatTone: "BUSINESS_ANALYST"
        }
    },
    {
        ...DEFAULT_BLUEPRINT_DETAILS,
        id: "RETAIL_WHATS_CHANGED_AND_WHY",
        name: "What's Changed Overview: Retail Sales",
        wizard: {
            ...SAMPLE_WHATS_CHANGED_WIZARD,
            base64StringLogo: KpiDriversIcon,
            base64StringBot: KpiDriversIcon,
            isKPIAnalysis: true,
            description: "Easily explore insights about Retail Sales to analyze the drivers behind what's changed from your date range",
            steps: {
                0: {
                    chatBlueprintId: "CHATAIBLE_WHATS_CHANGED"
                }
            },
            tags: [7, 10, "WHATS_CHANGED"],
            templateSample: "RETAIL_SALES_WHATS_CHANGED",
            templateSampleType: "DATASET",
            templateType: "KPI_DRIVERS",
            startInDashboard: true
        }
    },
    {
        ...DEFAULT_BLUEPRINT_DETAILS,
        id: "RETAIL_SALES_DEEP_DIVE",
        name: "Retail Sales: What's Changed Deep Dive",
        wizard: {
            ...SAMPLE_WHATS_CHANGED_WIZARD,
            base64StringLogo: WhatsChangedIcon,
            base64StringBot: WhatsChangedIcon,
            description: "Easily explore insights about Retail Sales What's Changed to analyze what's changed from your date range",
            steps: {
                0: {
                    chatBlueprintId: "CHATAIBLE_WHATS_CHANGED"
                }
            },
            tags: [7, 10, "WHATS_CHANGED"],
            templateSample: "RETAIL_SALES_DEEP_DIVE",
            templateSampleType: "DATASET",
            templateType: "WHATS_CHANGED_KPI",
            startInDashboard: false,
            chatTone: "BUSINESS_ANALYST"
        }
    },
    {
        ...DEFAULT_BLUEPRINT_DETAILS,
        id: "WHATS_CHANGED_TEMPLATE",
        name: "What's Changed Deep Dive",
        wizard: {
            ...SAMPLE_WHATS_CHANGED_WIZARD,
            base64StringLogo: WhatsChangedBaseIcon,
            base64StringBot: WhatsChangedBaseIcon,
            description: "A deep dive on what drives the outcome on your data",
            steps: {
                0: {
                    chatBlueprintId: "CHATAIBLE_WHATS_CHANGED"
                }
            },
            tags: ["WHATS_CHANGED"],
            templateSampleType: "DATASET",
            templateType: "WHATS_CHANGED_KPI",
            startInDashboard: false,
            chatTone: "BUSINESS_ANALYST"
        }
    },
    {
        ...DEFAULT_BLUEPRINT_DETAILS,
        id: "HEALTHCARE_FRAUD_WHATS_CHANGED_AND_WHY",
        name: "What's Changed Overview: Healthcare Fraud",
        wizard: {
            ...SAMPLE_WHATS_CHANGED_WIZARD,
            base64StringLogo: KpiDriversIcon,
            base64StringBot: KpiDriversIcon,
            isKPIAnalysis: true,
            description: "Easily explore insights about healthcare fraud to analyze the drivers behind what's changed from your date range",
            steps: {
                0: {
                    chatBlueprintId: "CHATAIBLE_WHATS_CHANGED"
                }
            },
            tags: [7, 10, "WHATS_CHANGED"],
            templateSample: "HEALTHCARE_FRAUD_WHATS_CHANGED",
            templateSampleType: "DATASET",
            templateType: "KPI_DRIVERS",
            startInDashboard: true
        }
    },
    {
        ...DEFAULT_BLUEPRINT_DETAILS,
        id: "PATIENT_VISITS_WHATS_CHANGED",
        name: "What's Changed Overview: Patient Visits",
        wizard: {
            ...SAMPLE_WHATS_CHANGED_WIZARD,
            base64StringLogo: HealthcareOverviewIcon,
            base64StringBot: HealthcareOverviewIcon,
            isKPIAnalysis: true,
            description: "Easily explore insights about patient visits to analyze the drivers behind what's changed from your date range",
            steps: {
                0: {
                    chatBlueprintId: "CHATAIBLE_WHATS_CHANGED"
                }
            },
            tags: [1, "WHATS_CHANGED"],
            templateSample: "PATIENT_VISITS_WHATS_CHANGED",
            templateSampleType: "DATASET",
            templateType: "KPI_DRIVERS",
            startInDashboard: true
        }
    },
    {
        ...DEFAULT_BLUEPRINT_DETAILS,
        id: "WHATS_CHANGED_OVERVIEW_TEMPLATE",
        name: "What's Changed Overview",
        wizard: {
            ...SAMPLE_WHATS_CHANGED_WIZARD,
            base64StringLogo: KpiOverviewBaseIcon,
            base64StringBot: KpiOverviewBaseIcon,
            isKPIAnalysis: true,
            description: "Understand what's driving shifts across your KPIs",
            steps: {
                0: {
                    chatBlueprintId: "CHATAIBLE_WHATS_CHANGED"
                }
            },
            tags: ["WHATS_CHANGED"],
            templateSampleType: "DATASET",
            templateType: "KPI_DRIVERS",
            startInDashboard: true
        }
    },
    {
        ...DEFAULT_BLUEPRINT_DETAILS,
        id: "CHATAIBLE_RAW_CHAT",
        name: "Just Chat",
        wizard: {
            base64StringLogo: JustChatUsecaseIcon,
            base64StringBot: JustChatUsecaseIcon,
            description: "Have open-ended conversations with an AI model, no data needed—just pure AI interaction."
        }
    },
    {
        ...DEFAULT_BLUEPRINT_DETAILS,
        id: "EMPLOYEE_HANDBOOK",
        name: "Employee Handbook",
        wizard: {
            ...SAMPLE_DOCSUM_WIZARD,
            base64StringLogo: DocSumHrIcon,
            base64StringBot: DocSumHrIcon,
            description: "Uncover answers in HR documents and PDFs with our template. It extracts key content—from policies to guidelines—and produces concise summaries for quick insights.",
            steps: {
                0: {
                    chatBlueprintId: "CHATAIBLE_DOCUMENT_SUMMARIZATION"
                }
            },
            tags: ["HUMAN_RESOURCES", 21],
            templateSample: "EMPLOYEE_HANDBOOK",
            templateSampleType: "ARTIFACT"
        }
    },
    {
        ...DEFAULT_BLUEPRINT_DETAILS,
        id: "CHATAIBLE_DOCUMENT_SUMMARIZATION",
        name: "Document Summarization",
        wizard: {
            ...SAMPLE_DOCSUM_WIZARD,
            base64StringLogo: DocSumBaseIcon,
            base64StringBot: DocSumBaseIcon,
            description: "Chat with a secure language model hosted on this computer about one of your documents",
            steps: {
                0: {
                    chatBlueprintId: "CHATAIBLE_DOCUMENT_SUMMARIZATION"
                }
            },
            tags: [21],
            templateSample: "EMPLOYEE_HANDBOOK",
            templateSampleType: "ARTIFACT"
        }
    }
];
const SparkTemplatesView = () => {
    const dispatch = useDispatch();
    const selectedFolder = useSelector((state) => foldersReducer.getSelectedFolder(state));
    const isBlueprintsLoading = useSelector((state) => globalReducer.getIsBlueprintsLoading(state));
    const isLoading = selectedFolder !== undefined && isBlueprintsLoading;
    const searchFilteredChatApps = useSelector((state) => viewReducer.getSearchFilteredChatTemplates(state));
    const searchFilteredBenchmarks = useSelector((state) => viewReducer.getSearchFilteredChatTemplates(state, "", "BENCHMARK"));
    const searchFilteredChatUseCases = useSelector((state) => viewReducer.getSearchFilteredUsecaseTemplates(state));
    const searchFilteredItems = [...searchFilteredChatApps, ...searchFilteredBenchmarks, ...searchFilteredChatUseCases];
    const retTemplates = useSelector((state) => viewReducer.getSearchFilteredMediaTemplates(state));
    const retSearchFilteredItems = [...retTemplates, ...searchFilteredItems];
    const notSavedFilteredItems = retSearchFilteredItems.filter((item) => item?.wizard?.isSavedWork !== true);
    const activeFilters = useSelector((state) => tagsReducer.getActiveFilters(state));
    const industryFilters = useSelector((state) => tagsReducer.getActiveFiltersByType(state, "INDUSTRY"));
    const functionFilters = useSelector((state) => tagsReducer.getActiveFiltersByType(state, "FUNCTION"));
    const typeFilters = useSelector((state) => tagsReducer.getActiveFiltersByType(state, "TYPE"));
    const retResults = notSavedFilteredItems.filter((item) => {
        if (activeFilters.length < 1) {
            return true;
        }
        const shouldShowIndustry = item?.tags?.some((tag) => industryFilters?.includes(tag));
        const shouldShowFunction = item?.tags?.some((tag) => functionFilters?.includes(tag));
        const shouldShowType = item?.tags?.some((tag) => typeFilters?.includes(tag));
        return !!(shouldShowIndustry || shouldShowFunction || shouldShowType);
    });
    const retOtherResults = retResults.filter((item) => {
        const notInHeroes = SPARK_TEMPLATES.map((template) => template.id);
        return !notInHeroes.includes(item.id);
    });
    const [selectedItem, setSelectedItem] = useState(undefined);
    const [doctype, setDoctype] = useState(undefined);
    const [videoDoctype, setVideoDoctype] = useState(undefined);
    const [showVideoDialog, setShowVideoDialog] = useState(false);
    const handleSelectedItem = (selectedItemId) => {
        const selectedTemplate = retResults.find((template) => template.id === selectedItemId);
        setSelectedItem(selectedTemplate);
        setDoctype(undefined);
    };
    //TODO WTF IS THIS???????
    useEffect(() => {
        setSelectedItem(undefined);
        dispatch(tagsReducer.resetActiveTagFilters());
    }, [selectedFolder]);
    useEffect(() => {
        dispatch(tagsReducer.resetActiveTagFilters());
        const allItemTags = notSavedFilteredItems
            .flatMap((item) => item?.tags)
            .filter((tag) => tag !== undefined && tag !== null);
        dispatch(tagsReducer.updateAllFilterOptions(allItemTags));
    }, []);
    useEffect(() => {
        if (!isLoading) {
            dispatch(tagsReducer.resetFilterOptions());
            const allItemTags = notSavedFilteredItems
                .flatMap((item) => item?.tags)
                .filter((tag) => tag !== undefined && tag !== null);
            dispatch(tagsReducer.updateAllFilterOptions(allItemTags));
        }
    }, [selectedFolder, isLoading]);
    useEffect(() => {
        if (videoDoctype) {
            setShowVideoDialog(true);
        }
    }, [videoDoctype]);
    const getTemplateHeroes = () => {
        const templateHeroes = [
            {
                type: "whats_changed_deep_dive",
                title: "What's Changed Deep Dive",
                heroImage: WhatsChangedDeepDive,
                description: "Analyze what’s driving a specific Key Performance Indicator (KPI) in your structured data. With just a few clicks, Aible creates an agent that uncovers the behaviors and trends influencing that KPI — and lets you adjust comparison periods to see how those impacts change over time.",
                doctype: "doc_deep_dive",
                videoDocuments: "video_deep_dive",
                templates: [
                    {
                        id: "RETAIL_SALES_DEEP_DIVE",
                        title: "Retail Sales",
                        description: "A deep dive on what drives Weekly Sales",
                        image: WhatsChangedRetail
                    },
                    {
                        id: "FINANCIAL_CONSUMER_COMPLAINTS_WHATS_CHANGED",
                        title: "Financial Consumer Complaints",
                        description: "A deep dive on what drives customer complaints",
                        image: WhatsChangedFinancial
                    },
                    {
                        id: "WHATS_CHANGED_TEMPLATE",
                        title: "What's Changed Deep Dive",
                        description: "A deep dive on what drives the outcome on your data",
                        image: WhatsChangedBaseIcon
                    }
                ]
            },
            {
                type: "whats_changed_overview",
                title: "What's Changed Overview",
                heroImage: WhatsChangedOverview,
                description: "Analyze overall performance across all Key Performance Indicators (KPIs) in your structured data. With just a few clicks, Aible creates an agent that identifies the key behaviors and trends shaping performance across every KPI — and lets you compare results over time.",
                doctype: "doc_overview",
                videoDocuments: "video_overview",
                templates: [
                    {
                        id: "RETAIL_WHATS_CHANGED_AND_WHY",
                        title: "Retail Sales",
                        description: "Understand what's driving shifts across every Retail KPI",
                        image: WhatsChangedOverviewRetail
                    },
                    {
                        id: "PATIENT_VISITS_WHATS_CHANGED",
                        title: "Patient Visits",
                        description: "Understand what's driving shifts across Patient Visit KPIs",
                        image: HealthcareOverviewIcon
                    },
                    {
                        id: "WHATS_CHANGED_OVERVIEW_TEMPLATE",
                        title: "What's Changed Overview",
                        description: "Understand what's driving shifts across your KPIs",
                        image: KpiOverviewBaseIcon
                    }
                ]
            }
        ];
        if (!isEnabled("spark-with-partners")) {
            templateHeroes.push({
                type: "document_question_answering_and_chat",
                title: "Document Question Answering and Chat",
                heroImage: DocumentQuestion,
                description: "Access insights from your unstructured data with ease. With just a few clicks, Aible creates an agent that extracts and summarizes the most relevant information from your documents — helping you uncover insights, patterns, and answers faster than ever.",
                doctype: "doc_document_summarization",
                videoDocuments: "video_document_summarization",
                templates: [
                    {
                        id: "EMPLOYEE_HANDBOOK",
                        title: "Employee Handbook",
                        description: "Quickly get HR answer to employees questions ",
                        image: DocumentCustomerService
                    },
                    {
                        id: "CHATAIBLE_RAW_CHAT",
                        title: "Context Aware Chat",
                        description: "Chat with a secure language model hosted on this computer in the context of your data",
                        image: DocumentContextAwareChat
                    },
                    {
                        id: "CHATAIBLE_DOCUMENT_SUMMARIZATION",
                        title: "Document Summarization",
                        description: "Chat about one of your documents",
                        image: DocSumBaseIcon
                    }
                ]
            });
        }
        return templateHeroes;
    };
    return (React.createElement("div", { className: "f-full bg-white" },
        React.createElement("div", { className: "p-8 text-center flex items-center justify-center gap-4" },
            React.createElement("div", { className: "text-3xl bold" }, "9 Templates available. Discover the right one for you."),
            React.createElement(Button, { type: "secondary", onClick: () => dispatch(updateType(VIEW_TYPE.NEW_CHAT)) },
                React.createElement("img", { src: BackToChat, className: "mr-2" }),
                React.createElement("span", { className: "bold" }, "Go Back to Chat"))),
        React.createElement("div", { className: cn("grid grid-cols-3 gap-4 px-5 items-start", isEnabled("spark-with-partners") && "grid-cols-2 items-center max-w-7xl mx-auto") }, getTemplateHeroes().map((templateHero) => (React.createElement(TemplateHero, { key: templateHero.title, type: templateHero.type, title: templateHero.title, heroImage: templateHero.heroImage, description: templateHero.description, documents: templateHero.doctype, videoDocuments: templateHero.videoDocuments, setDoctype: setDoctype, setVideoDoctype: setVideoDoctype, templates: templateHero.templates, selectedItem: selectedItem, updateSelectedItem: handleSelectedItem, disable: isBlueprintsLoading, isLoading: isBlueprintsLoading })))),
        React.createElement("div", { className: "py-6 px-5" },
            React.createElement("div", { className: "text-xl bold text-center" },
                retOtherResults.length,
                " Other Agent Templates"),
            React.createElement("div", { className: "text-center text-base text-[#64748B]" }, "You can try these agents using the included sample data. Contact Aible to learn how to add these templates to your account."),
            React.createElement(TemplatesFilters, null),
            React.createElement("div", { className: "pt-6" },
                React.createElement(SparkTemplatesList, { data: retOtherResults, selectedItem: selectedItem, updateSelectedItem: handleSelectedItem }))),
        React.createElement(SparkRightPanel, { selectedItem: selectedItem, setSelectedItem: handleSelectedItem, setDoctype: setDoctype, setVideoDoctype: setVideoDoctype }),
        React.createElement(SparkDocsRightPanel, { doctype: doctype, setDoctype: setDoctype }),
        React.createElement(Dialog, { open: showVideoDialog, onOpenChange: () => {
                setShowVideoDialog(false);
                setVideoDoctype(undefined);
            } },
            React.createElement(DialogContent, null,
                React.createElement(DialogHeader, null,
                    React.createElement(DialogTitle, null,
                        videoDoctype === "video_overview" && "What's Changed Overview",
                        videoDoctype === "video_deep_dive" && "What's Changed Deep Dive",
                        videoDoctype === "video_document_summarization" && "Document Summarization")),
                React.createElement("div", null,
                    videoDoctype === "video_overview" && (React.createElement("div", { className: "py-6" },
                        React.createElement("video", { controls: true, width: "622" },
                            React.createElement("source", { src: VideoOverview, type: "video/mp4" })))),
                    videoDoctype === "video_deep_dive" && (React.createElement("div", { className: "py-6" },
                        React.createElement("video", { controls: true, width: "622" },
                            React.createElement("source", { src: VideoDeepDive, type: "video/mp4" })))),
                    videoDoctype === "video_document_summarization" && (React.createElement("div", { className: "py-6" },
                        React.createElement("video", { controls: true, width: "622" },
                            React.createElement("source", { src: VideoDocSum, type: "video/mp4" })))))))));
};
export default SparkTemplatesView;
